module.exports = __webpack_public_path__ + "media/background_blue_foggy.7b121032.mp4";